import React from 'react';
import styles from './Loader.module.scss';

const Loader: React.FC = () => {
  return <span className={styles.loader}></span>;
};

export default Loader;
